import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createFormulaire = async (data) => {
      try {
        const response = await api.create(url.ADD_FORMULAIRES, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getFormulaire = async () => {
      try {
        const response = await api.get(url.GET_FORMULAIRES);
        return response;
      } catch (error) {
        throw error;
      }
  };
  

  export const updateFormulaire = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_FORMULAIRES +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const getFormulaireyId = async (id) => {
        try {
          const response = await api.get(`/instructions/${id}`);
          return response;
        } catch (error) {
          throw error;
        }
    };
    export const getFormulaireByType = async (type) => {
      try {
        const response = await api.get(`/instructions/type/${type}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const deleteFormulaire = async (id) => {
        try {
            const response = await api.delete(`/catalogs/delete/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
      };

 
